import React from "react";
import { useField } from "formik";
import { uniqBy } from "lodash/array";
import { useSelector } from "react-redux";
import { getActiveLivestockAgentDeployment, getLabels } from "selectors";
import { SelectFieldOption } from "components/Form/FormikControls";
import { LabelSelectorField } from "./LabelSelectorField";

interface SundryTemplateLabelSelectorFieldProps {
  name: string;
  label: string;
  tooltip?: string;
  disabled?: boolean;
  required?: boolean;
}

export const SundryTemplateLabelSelectorField = ({
  name,
  label,
  tooltip = null,
  disabled = false,
  required = false,
}: SundryTemplateLabelSelectorFieldProps) => {
  // 1. Specialised case where we aren't in the context of a sale.
  // This means we cant filter the deployment labels by species, instead we are just
  // uniquing them by name - which is how they are interpreted by mincenous anyway.
  // 2. Only for Livestock Agents
  // 3. No need to allow creation.
  const deploymentId: number = useSelector(
    getActiveLivestockAgentDeployment,
  )?.id;

  const labels: DeploymentLabel[] = Object.values(useSelector(getLabels));

  const [{ value: labelsInUse = [] }] = useField(name);

  const options: SelectFieldOption[] = uniqBy(
    labels.filter(
      deploymentLabel =>
        labelsInUse.includes(deploymentLabel.id) ||
        (deploymentLabel.deployment_id === deploymentId &&
          deploymentLabel.is_manual_charge_label &&
          !deploymentLabel.deprecated),
    ),
    "name",
  ).map(option => ({
    label: option.name,
    value: option.id,
  }));

  return (
    <LabelSelectorField
      name={name}
      label={label}
      tooltip={tooltip}
      required={required}
      disabled={disabled}
      options={options}
      placeHolder="Extra labels for this sundry."
    />
  );
};
